import { render } from "./FooterComponent.vue?vue&type=template&id=e6251b7a&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=e6251b7a&scoped=true&lang=css"
import "./FooterComponent.vue?vue&type=style&index=1&id=e6251b7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6251b7a"]])

export default __exports__